import { print } from 'graphql';

import createOneVoteMutation from '~/shared/graphql-queries/votes/create-one-vote-mutation';
import type { BuilderType } from '~/types';

type CreateOneVoteArgs = Readonly<{
  course?: string;
}>;

export const votesTagTypes = [] as const;

export const getVotesQuery = (builder: BuilderType) => {
  return {
    createOneVote: builder.mutation<unknown, CreateOneVoteArgs>({
      query: (args) => ({
        url: '',
        method: 'POST',
        body: JSON.stringify({
          query: print(createOneVoteMutation),
          variables: {
            course: args?.course,
          },
        }),
      }),
    }),
  };
};
